export default __webpack_public_path__ + "static/Press_Releases_01-9ce0312087d1742284f147e3b25d61b9.jpg";